import {Drawing} from '@domain/production-schedule/drawing';
import {MachineQualityForProductionSchedule} from '@domain/production-schedule/machine-quality-for-production-schedule';

export function calculateDrawingHeightInPicks(drawing: Drawing, machineQuality: MachineQualityForProductionSchedule): number {
  return drawing.threadByThread ? drawing.dimensionsInPixels.heightInPx : drawing.dimensionsInPixels.heightInPx * machineQuality.weaveStructure.picksPerColorLine;
}
